export default "__VITE_ASSET__CxfFxdm7__"